// src/api/userService.ts
import axiosInstance from 'api/axiosInstance';
import { ApiResponse } from 'types/ApiResponse';
import { IUser } from 'types/User';

export const userService = {
  getProfile: async (): Promise<Partial<IUser>> => {
    const response = await axiosInstance.get<Partial<IUser>>('/auth/profile');
    return response.data;
  },

  getUserByNumberPhone: async (numberPhone: string): Promise<any> => {
    const response = await axiosInstance.post<any>(`/user-by-number-phone`, {
      numberPhone: numberPhone,
    });
    return response.data;
  },

  getUserConnected: async (): Promise<ApiResponse<IUser>> => {
    const response = await axiosInstance.get<any>(`/users/me/profil`);
    return response.data;
  },

  updateUser: async (user: Partial<IUser>): Promise<ApiResponse<IUser>> => {
    const response = await axiosInstance.patch<any>(`/users`, user);
    return response.data;
  },
};
